import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {TeslaGameConfig} from "../../../TeslaGameConfig";
import {MathHelper} from "../../../utils/MathHelper";

/**
 * Created by h3 on 2017-09-20.
 */

export class TeslaBetLineWinPresentationView extends BaseView {

    private static BET_LINE_PART: string = "betLine";

    private _layer: ScalableLayer;
    private _betLineContainer: PIXI.Container;

    constructor(resourcesGroup: ResourcesGroupName) {
        super(resourcesGroup);
        this._betLineContainer = new PIXI.Container();
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.BET_LINES.name);
        this._layer.addChild(this._betLineContainer);
    }

    protected initAnimations(): void {
    }

    /**
     * Creates separate animations for each winning line in IBetLineWinData.
     *
     * @param {IBetLineWinData[]} betWinsData
     * @returns {TimelineLite[]}
     */
    public getBetLineAnimations(betWinsData: IBetLineWinData[]): TimelineLite[] {
        let betLines: TimelineLite[] = [];
        for (let i: number = 0; i < betWinsData.length; i++) {
            let betLineWinData: IBetLineWinData = betWinsData[i];
            betLines.push(this.getBetLineAnimation(betLineWinData));
        }

        return betLines;
    }

    /**
     * Creates a animation for a single bet line
     *
     * @param {IBetLineWinData} betLineWinData
     * @returns {TimelineLite}
     */
    private getBetLineAnimation(betLineWinData: IBetLineWinData): TimelineLite {
        let linePoints = TeslaBetLineWinPresentationView.getPointsFromBetLine(betLineWinData);
        return this.getPartialSprites(linePoints);
    }

    private getPartialSprites(linePoints: PIXI.Point[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        //Parts
        const visualWidth = 202;
        for (let i = 0; i < linePoints.length - 1; i++) {
            let part: TimelineLite = new TimelineLite();
            let linePoint: PIXI.Point = linePoints[i];
            let nextLinePoint = new PIXI.Point();

            if (linePoints[i + 1]) {
                nextLinePoint = linePoints[i + 1];
            }

            let angle = MathHelper.angleBetweenPoints(linePoint, nextLinePoint);
            let distance = MathHelper.distanceBetweenPoints(linePoint, nextLinePoint);

            const connectingLine = new TimelineSprite(GameResources.getTextures(TeslaBetLineWinPresentationView.BET_LINE_PART));
            connectingLine.x = linePoint.x;
            connectingLine.y = linePoint.y;
            connectingLine.width = distance * (connectingLine.width / visualWidth);
            connectingLine.scale.y = 1;
            connectingLine.anchor.set(0.08, 0.5);
            connectingLine.hide();
            connectingLine.rotation = angle;
            connectingLine.blendMode = PIXI.BLEND_MODES.ADD;
            this._betLineContainer.addChild(connectingLine);

            part.add(connectingLine.getAnimationAutoShowHide(true, true));
            part.add(() => this._betLineContainer.removeChild(connectingLine));
            tl.add(part, "-= 0.3");
        }


        return tl;
    }

    public clearView() {
        this._betLineContainer.removeChildren();
    }

    public addAmountForToggle(item: PIXI.BitmapText): void {
        this._betLineContainer.addChild(item);
    }

    private static getPointsFromBetLine(betLineWinData: IBetLineWinData): PIXI.Point[] {
        const linePoints: PIXI.Point[] = [];
        let betLine = betLineWinData.betLine;

        for (let i: number = 0; i < betLineWinData.nrOfSymbols; i++) {
            const symId: number = betLine[i];
            const basePosition: number[] = Helper.getSymbolPositions(i, symId);
            const points = new PIXI.Point(basePosition[0], basePosition[1]);
            linePoints.push(points);
        }
        return linePoints;
    }
}

